import { Form, Link, useNavigate } from "@remix-run/react";
import { Button } from "./ui/button";
import { cn } from "~/lib/utils";
import useScrollPosition from "~/hooks/useScrollPosition";

export default function Header({ isLoggedIn }) {
  const scrollPosition = useScrollPosition();
  const navigate = useNavigate();

  return (
    <header
      className={cn(
        "fixed top-0 z-10 w-full border-b border-transparent bg-transparent py-6 transition-colors",
        scrollPosition > 0 && "border-emerald-200 bg-emerald-50",
      )}
    >
      <div className="container flex w-full justify-between">
        <Link to="/">
          <img
            alt="knack sheet logo"
            src="/knack-sheet-logo.svg"
            className="hidden h-10 sm:block"
          />
          <img
            alt="knack sheet logo"
            src="/logo-mark.svg"
            className="h-10 sm:hidden"
          />
        </Link>
        <nav className="flex gap-2 items-center">
          <button 
            className="px-3 py-2 font-medium transition-colors hover:text-emerald-500"
            onClick={() => navigate("/documentation")}
          >
            Docs
          </button>
          {isLoggedIn && (
            <>
              <Form method="post" action="/logout">
                <button 
                  className="px-3 py-2 mr-2 font-medium transition-colors hover:text-emerald-500"
                >
                  Logout
                </button>
              </Form>
              <Button onClick={() => navigate("/dashboard")}>Dashboard</Button>
            </>
          )}
          {!isLoggedIn && (
            <>
              <button 
                className="px-3 py-2 mr-2 font-medium transition-colors hover:text-emerald-500"
                onClick={() => navigate("/login")}
              >
                Login
              </button>
              <Button onClick={() => navigate("/login?try")}>
                Try for Free
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
